import { motion } from "framer-motion";
import { Sparkles, Waves, Users } from "lucide-react";
import { FadeUp } from "@/components/Reveal";

const Card = ({ className, children, delay = 0, testId }) => (
  <motion.div
    data-testid={testId}
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    whileHover={{ y: -6 }}
    transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1], delay }}
    className={`relative overflow-hidden rounded-[32px] p-7 xl:p-9 ${className}`}
  >
    {children}
  </motion.div>
);

export const Features = () => (
  <section data-testid="features-section" className="px-5 py-24 md:px-10 md:py-32">
    <div className="mx-auto max-w-[1440px]">
      <FadeUp className="mb-12">
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-cyan">Why us</p>
        <h2 className="mt-3 font-display text-4xl font-extrabold uppercase leading-[0.9] tracking-tight sm:text-5xl lg:text-7xl">Built<br />different</h2>
      </FadeUp>
      <div className="grid grid-cols-1 gap-4 lg:grid-cols-12 lg:grid-rows-[300px_300px]">
        <Card testId="feature-comfort" className="min-h-[340px] lg:col-span-6 lg:row-span-2">
          <img src="/img/insane-heroes.jpg" alt="Insane Heroes comic print socks" className="absolute inset-0 h-full w-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/40 to-transparent" />
          <div className="relative flex h-full flex-col justify-end">
            <p className="font-display text-[1.5rem] font-extrabold uppercase leading-[0.9] sm:text-4xl lg:text-[2.8vw] 2xl:text-[3rem]">Soft like a<br /><span className="text-lime">compliment</span></p>
            <p className="mt-3 max-w-sm text-base text-haze">Cushioned where it counts, breathable everywhere else.</p>
          </div>
        </Card>
        <Card testId="feature-prints" delay={0.1} className="bg-lime text-ink lg:col-span-6">
          <Sparkles className="h-10 w-10" strokeWidth={2.4} />
          <p className="mt-6 font-display text-3xl font-extrabold uppercase leading-none lg:text-4xl">Prints that talk</p>
          <p className="mt-3 max-w-md text-base font-medium">Your socks say what your outfit was too shy to.</p>
        </Card>
        <Card testId="feature-wash" delay={0.2} className="bg-pink lg:col-span-3">
          <Waves className="h-9 w-9" strokeWidth={2.4} />
          <p className="mt-6 font-display text-2xl font-extrabold uppercase leading-none lg:text-xl xl:text-2xl">Wash-proof color</p>
          <p className="mt-2 text-sm">Stays loud, wash after wash.</p>
        </Card>
        <Card testId="feature-fit" delay={0.3} className="border border-violet/50 bg-plum lg:col-span-3">
          <Users className="h-9 w-9 text-cyan" strokeWidth={2.4} />
          <p className="mt-6 font-display text-2xl font-extrabold uppercase leading-none lg:text-xl xl:text-2xl">Unisex insane design</p>
          <p className="mt-2 text-sm text-haze">Made for every foot. Zero rules.</p>
        </Card>
      </div>
    </div>
  </section>
);
